import styled from "styled-components";

// What a linked connection looks like once it is set: a bordered list of label/value rows, shared so
// the Analytics and the Search Console sections read as the same thing with different rows in it.
export const DetailsGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
`;

export const DetailRow = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid #e2e8f0;
    &:last-child { border-bottom: none; }
    background: #ffffff;
`;

export const DetailLabel = styled.div`
    width: 112px;
    font-size: 0.78rem;
    font-weight: 600;
    color: #64748b;
    flex-shrink: 0;
    font-family: "Inter", system-ui, sans-serif;
`;

export const DetailValue = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.875rem;
    color: #0f172a;
    font-family: "Inter", system-ui, sans-serif;
`;

export const IdBadge = styled.span`
    background: #f1f5f9;
    color: #475569;
    font-size: 0.72rem;
    font-weight: 600;
    padding: 2px 7px;
    border-radius: 4px;
    font-family: monospace;
`;

export const DetailsWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
